<template>
<div>
    <div v-if="filteredRanking">
        {{rankingGroup.name}}
        <table class="row column ranking">
            <tr v-for="ranking_line,i of filteredRanking"
                :id="ranking_line.team.id"
                v-bind:class="{win:i<9, lose: i>=9}"
                @click="teamClicked(ranking_line.team.id)">
                <td>{{i+1}}.</td>
                <td><img class="small-team-icon" :src="getRosterIcon(ranking_line.team.ref_roster)" alt="team"></td>
                <td>{{ranking_line.team.name}}</td>
                <td>{{ranking_line.ranking_points}} pts</td>
            </tr>
        </table>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'

export default {
  name: 'rankingGroupPanel',
  components: {
    spinner
  },
  data () {
    return {
    }
  },
  props: {
    'rankingGroup': null
  },
  computed: {
    ...mapGetters([
      'ranking',
      'activatedRankingGroups',
      'activatedLeague',
      'weekListForLeague',
      'activatedClub'
    ]),
    lastWeek: function () {
      if (this.weekListForLeague) {
        return store.getters.lastWeekListForLeague(this.activatedLeague)
      }
      return null
    },
    filteredRanking: function () {
      console.log('filteredRanking')
      if (this.lastWeek !== undefined && this.lastWeek !== null) {
        return store.getters.orderedRankingForGroupAndDay(this.rankingGroup.id, this.lastWeek.id)
      }
      return null
    }
  },
  methods: {
    getRosterIcon (roster) {
      return '/static/imgs/team-icons/' + roster.replace(/\s+/, '') + '.png'
    },
    teamClicked (teamId) {
      let t = teamId.toString()
      this.$router.push({name: 'TeamDetail', params: { id: t }})
    }
  },
  created () {
    store.dispatch('getRanking')
    store.dispatch('getWeekList')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ranking{
    font-weight: 300;
}

div.ranking-line div{
    margin:0;
    padding:0;
}

.trend-icon-up {
    color: #009900;
    -ms-transform: rotate(-45deg); /* IE 9 */
    -webkit-transform: rotate(-45deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
}

.trend-icon-down {
    color: #CC0000;
    -ms-transform: rotate(-135deg); /* IE 9 */
    -webkit-transform: rotate(-135deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
}

.trend-icon-neutral {
    color: #BBBBBB;
    -ms-transform: rotate(-90deg); /* IE 9 */
    -webkit-transform: rotate(-90deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
}

.small-team-icon {
    width: 25px;
    height: 25px;
}

.ranking tr td{
    padding: 0.5rem 0rem;
    font-size: 0.8em;
}

.ranking tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.ranking tr:nth-of-type(even) {
    transition: background-color 0.15s;
    background-color: #ffffff;
}

.ranking td:nth-of-type(5n) {
    font-weight: 400;
}

.ranking tr:hover{
    background-color: #ACB5C3;
    cursor: pointer;
}
.ranking tr:hover td:nth-of-type(5n){
    background-color: #ACB5C3;
    cursor: pointer;
}


.ranking tr td{
    text-align: center;
}

.ranking tr td img{
    width: 25px;
    height: 25px;
}

.ranking td:nth-of-type(1) {
    padding: 0rem 0.5rem
}

.ranking td:nth-of-type(5) {
    padding: 0rem 0.3rem
}

.win {
    border-left-style: solid;
    border-left-width: 4px;
    border-left-color: #009900;
}

.lose {
    border-left-style: solid;
    border-left-width: 4px;
    border-left-color: #CC0000;
}
</style>



// WEBPACK FOOTER //
// ranking-group-panel.vue?5188fd34